"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.space = void 0; //        Index #:     0  1  2  3   4   5   6   7   8

var space = [0, 4, 8, 12, 16, 20, 24, 28, 32];
exports.space = space;